var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.isReady)?[(_vm.location)?_c('Header',{attrs:{"name":_vm.location.Name,"logo":_vm.location.LogoUrl}}):_vm._e(),_c('v-main',[_c('router-view')],1)]:_c('Loading'),_c('v-chip',{staticClass:"pa-1 version",attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.version))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }